import wx from 'weixin-js-sdk'

class Payment {
  constructor() {
    this.sign = null // 微信支付-验证数据

    this.payModelId = null // 支付模式
    this.signUrl = null // 统一支付接口
    this.openid = null // 用户id
    this.payPlatformId = null // 服务名
    this.payPriceTotal = null // 金额
    this.orderId = null // 订单id
    this.title = null // 券号
    this.jumpUrl = null // h5支付-成功后跳转地址

  }

  // 打开收银台 res所需数据 isWxNet是否微信
  static openBank(res = {}, isWxNet = true) {

    // 跳转自己平台的收银台
    // const BANK_ROUTER = isWxNet ? '/pages/cashier/index' : 'https://wx.tuhu.cn/vue/wx/pages/cashier/index'

    if (!res.payModelId) return tuhu.toast('无服务名称')

    if (!res.payPlatformId) return tuhu.toast('无服务金额')

    if (!res.payPriceTotal) return tuhu.toast('无券号')

    if (!res.signUrl) return tuhu.toast('无支付接口')

    if (!res.orderId) return tuhu.toast('无支付模式类型')

    if (!res.title) return tuhu.toast('无用户id')

    const pay = new Payment()
    pay.payModelId = res.payModelId
    pay.payPlatformId = res.payPlatformId
    pay.payPriceTotal = res.payPriceTotal
    pay.signUrl = res.signUrl
    pay.title = res.title
    pay.orderId = res.orderId

    // 先支付没有orderId
    // pay.orderId = res.orderId || null

    pay.jumpUrl = res.jumpUrl || null

    isWxNet ? pay.config(pay.orderId) : pay.h5pay()
  }

  // h5支付 成功失败都返回jumpUrl
  async h5pay() {
    let sign = await tuhu.fetch(`${this.signUrl}`, {
        method: 'post', 
        body: JSON.stringify({
            orderId: this.orderId,
            jumpUrl: '',
            openid: '',
            payModelId: this.payModelId,
            payPlatformId: this.payPlatformId,
            payPriceTotal: this.payPriceTotal,
            title: this.title
})
    })
    .then((res) => {
      location.href = res.data.mwebUrl
    })
    return sign
  }

  // 微信调起支付1
  config(orderId) {
    return this.getSign().then(() => {
      if (wx) {
        return this.wxConfig(orderId)
      }
    })
  }

  // 微信调起支付2
  async getSign() {
    let sign = await tuhu.fetch(`${this.signUrl}`, {
        method: 'post', 
        body: JSON.stringify({
            orderId: this.orderId,
            jumpUrl: '',
            openid: '',
            payModelId: this.payModelId,
            payPlatformId: this.payPlatformId,
            payPriceTotal: this.payPriceTotal,
            title: this.title
})
    })
      .then((res) => {
        console.log('接口获取验证数据', res)

        if (res && res.code === '200') {
          // console.log('getSign成功', res)
          this.sign = res.data
        } else {
          tuhu.toast(res.message || '支付失败，200')
          console.log('getSign失败', res.message || '网络错误')
        }
      })
    return sign
  }

  // 微信调起支付3
  wxConfig(orderId) {
    // console.log('验证sign', this.sign)
    let _this = this
    wx.chooseWXPay({
      timestamp: this.sign.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: this.sign.nonceStr, // 支付签名随机串，不长于 32 位
      package: this.sign.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: this.sign.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: this.sign.paySign, // 支付签名
      success: function (res) {
        // 支付成功后的回调函数
        // console.log('支付成功后的回调函数', res)
        setTimeout(() => {
          // this.sign.outTradeNo: 支付流水号微信orderId 下午茶用到
          console.log('ress', _this.sign)
        //   Payment.toOrderSuccess(serviceTickitCode, orderId, _this.sign && _this.sign.orderId)
        }, 200)

      }
    })
  }

  // 跳转
  static toOrderSuccess = (serviceTickitCode, orderId, outTradeNo) => {
    tuhu.redirectTo({
      url: '/pages/orderResult/index',
      query: {
        tCode: serviceTickitCode,
        oId: orderId,
        oNo: outTradeNo
      }
    })
  }

}

export default Payment



// WEBPACK FOOTER //
// ./lib/commons/xkPay.js